import type { QueryKey } from '@tanstack/react-query';

/** `freeform_thread` SSE (payload `{ caseId }`, ids only) → what to refetch. */
export function freeformThreadInvalidations(data: { caseId?: string }): QueryKey[] {
  if (!data.caseId) return [];
  return [
    ['freeform-thread', data.caseId],
    ['case-checkpoints', data.caseId],
    ['freeform-artifact', data.caseId],
  ];
}
